import { useCallback, useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { DT_TYPES, money } from "@/lib/daytime";

export function GiftsAdmin() {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => { api.get("/gifts/admin").then((r) => setRows(r.data)).catch((e) => toast.error(apiErr(e))); }, []);
  useEffect(() => { load(); }, [load]);
  const resend = async (id) => { try { await api.post(`/gifts/admin/${id}/resend`); toast.success("Gift email sent"); load(); } catch (e) { toast.error(apiErr(e)); } };
  return (
    <div className="space-y-2 mt-3" data-testid="gifts-admin">
      <p className="text-xs text-slate-500">Gift codes are emailed automatically when you confirm the buyer's payment in Orders.</p>
      {rows.length === 0 && <p className="text-sm text-slate-400">No gift cards yet.</p>}
      {rows.map((g) => (
        <div key={g.id} className="bg-white border border-slate-200 rounded-2xl p-3 flex flex-wrap justify-between gap-2" data-testid={`gift-row-${g.id}`}>
          <div><p className="font-bold text-navy">{DT_TYPES[g.kind]} · {money(g.amount)} · <span className="capitalize">{g.status.replace("_", " ")}</span></p>
            <p className="text-xs text-slate-500">From {g.buyer_name} → {g.recipient_name} ({g.recipient_email}){g.code ? ` · ${g.code}` : ""}</p></div>
          {g.status !== "redeemed" && g.status !== "pending_payment" && <Button size="sm" variant="outline" className="rounded-full" onClick={() => resend(g.id)} data-testid={`gift-resend-${g.id}`}>Resend email</Button>}
        </div>
      ))}
    </div>
  );
}
